/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type ReactNode } from 'react';

import { jsx } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightManager as DeprecatedSpotlightManager } from '@atlaskit/onboarding';
import { fg } from '@atlaskit/platform-feature-flags';
import { PopoverProvider as AKPopoverProvider } from '@atlaskit/spotlight';

export interface SpotlightManagerProps {
	/**
	 * A single child.
	 */
	children: ReactNode;

	/**
	 * Boolean prop for toggling blanket transparency.
	 */
	// eslint-disable-next-line @repo/internal/react/boolean-prop-naming-convention
	blanketIsTinted?: boolean;
}

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */
const SpotlightManager: {
	({ children, blanketIsTinted }: SpotlightManagerProps): React.JSX.Element;
	displayName: string;
} = ({ children, blanketIsTinted }: SpotlightManagerProps): React.JSX.Element => {
	if (fg('ads_spotlight_migration_engagekit_ts')) {
		return <AKPopoverProvider>{children}</AKPopoverProvider>;
	}

	return (
		<DeprecatedSpotlightManager blanketIsTinted={blanketIsTinted}>
			{children}
		</DeprecatedSpotlightManager>
	);
};

SpotlightManager.displayName = 'SpotlightManager';

export { SpotlightManager };
